import script from "./Cabecalho.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cabecalho.vue?vue&type=script&setup=true&lang=ts"

import "./Cabecalho.vue?vue&type=style&index=0&id=7e98f9fc&lang=css"

const __exports__ = script;

export default __exports__